module.exports = __webpack_public_path__ + "fonts/brandon-grotesque-medium-italic-58a8a3c40866a.3a10f20.woff2";